// extracted by mini-css-extract-plugin
export default {"review-service-logo":"_2TBHl8XknEWK3PZ7U_fxti"};